export const font = {
    fonts: {
      heading: 'Inter, system-ui, -apple-system, sans-serif',
      body: 'Inter, system-ui, -apple-system, sans-serif',
      mono: 'SFMono-Regular, Monaco, Consolas, "Liberation Mono", "Courier New", monospace',
      jakarta: "'Plus Jakarta Sans', system-ui, sans-serif",
    },
    fontSizes: {
      xs: "12px",
      sm: "14px", 
      md: "16px",
      lg: "18px",
      xl: "20px",
      "2xl": "24px",
      "3xl": "30px",
      "4xl": "36px",
      "5xl": "48px",
      "6xl": "64px",
    },
    fontWeights: {
      normal: 400,
      medium: 500,
      semibold: 600,
      bold: 700,
      extrabold: 800,
    }
};